exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkbox-wrapper label{display:flex;flex-wrap:wrap;align-self:flex-start}.checkbox-wrapper .checkbox-title{width:calc(100% - 30px)}", ""]);

